import { action, observable } from 'mobx';

class NewUI {
  @observable enable =
    process.env.NODE_ENV !== 'production' ||
    window.location.hostname === 'mlestaging.icsconnect.com.au' ||
    window.location.hostname === 'localhost';

  @action toggleNewUi = () => {
    this.enable = !this.enable;
  };
}

window.__newui = new NewUI();
